import React from "react";
import {withNamespaces} from "react-i18next";

const FOCUS_AREAS = [
  { key: 'fuel_your_body', label: 'trainer_day_focus_fuel', description: 'trainer_day_focus_fuel_desc' },
  { key: 'know_your_numbers', label: 'trainer_day_focus_numbers', description: 'trainer_day_focus_numbers_desc' },
  { key: 'master_the_machines', label: 'trainer_day_focus_machines', description: 'trainer_day_focus_machines_desc' },
  { key: 'train_with_a_plan', label: 'trainer_day_focus_plan', description: 'trainer_day_focus_plan_desc' },
];

const FocusAreaStep = (props) => {
  const { t, selectedFocusArea, onChange } = props;
  return (
    <div className="focus-area-step">
      <h3><span className='red-text'>{t('trainer_day_step_2')}</span>{t('trainer_day_focus_area_title')}</h3>
      <div className='focus-area-selection'>
        {FOCUS_AREAS.map((area) => (
          <div key={area.key} className='radio focus-area-item'>
            <input
              type="radio"
              name="focus_area"
              id={`focus_${area.key}`}
              value={area.key}
              checked={selectedFocusArea === area.key}
              onChange={() => onChange(area.key)}
            />
            <label htmlFor={`focus_${area.key}`}>
              <strong>{t(area.label)}</strong> — {t(area.description)}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default withNamespaces()(FocusAreaStep);
